export type AuthErrorLike = {
  code?: string;
  message?: string;
};

export function normalizeAuthEmail(value: string) {
  return value.trim().toLowerCase();
}

export function isDuplicateAuthEmailError(error: AuthErrorLike) {
  const value = `${error.code || ""} ${error.message || ""}`.toLowerCase();
  return /user_already_exists|user already registered|already (?:been )?registered|email (?:address )?already exists/.test(value);
}

export function isUnconfirmedAuthEmailError(error: AuthErrorLike) {
  const value = `${error.code || ""} ${error.message || ""}`.toLowerCase();
  return /email_not_confirmed|email (?:address )?(?:is )?not confirmed/.test(value);
}
